'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { X, ChevronLeft, ChevronRight, Camera } from 'lucide-react';

const galleryImages = [
{ id: 'img-001', src: "https://img.rocket.new/generatedImages/rocket_gen_img_1002e08ff-1772253453961.png", alt: 'Grand ballroom with golden chandeliers and white floral arrangements for wedding reception', thumb: "https://img.rocket.new/generatedImages/rocket_gen_img_1002e08ff-1772253453961.png" },
{ id: 'img-002', src: "https://images.unsplash.com/photo-1677768062274-fdd45caac233", alt: 'Elegant reception hall with crystal chandelier and round dinner tables with white linen', thumb: "https://images.unsplash.com/photo-1677768062274-fdd45caac233" },
{ id: 'img-003', src: "https://images.unsplash.com/photo-1718900743556-3bd1f52ebe41", alt: 'Wedding ceremony setup with rose petal aisle and white arch with floral garlands', thumb: "https://images.unsplash.com/photo-1718900743556-3bd1f52ebe41" },
{ id: 'img-004', src: "https://images.unsplash.com/photo-1629307095660-d73f0cc2fb03", alt: 'Banquet hall dining setup with floral centerpieces and uplighting on ornate walls', thumb: "https://images.unsplash.com/photo-1629307095660-d73f0cc2fb03" },
{ id: 'img-005', src: "https://img.rocket.new/generatedImages/rocket_gen_img_11d43ae23-1772258442483.png", alt: 'Stage area with dramatic red and gold lighting and traditional Indian wedding mandap', thumb: "https://img.rocket.new/generatedImages/rocket_gen_img_11d43ae23-1772258442483.png" }];


export default function VenueGallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openLightbox = (idx: number) => {setActiveIndex(idx);setLightboxOpen(true);};
  const closeLightbox = () => setLightboxOpen(false);
  const prev = () => setActiveIndex((i) => i === 0 ? galleryImages.length - 1 : i - 1);
  const next = () => setActiveIndex((i) => i === galleryImages.length - 1 ? 0 : i + 1);

  return (
    <>
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-10 pt-4">
        <div className="grid grid-cols-4 grid-rows-2 gap-2 h-[420px] rounded-2xl overflow-hidden">
          {/* Main large image */}
          <div
            className="col-span-2 row-span-2 relative cursor-pointer group"
            onClick={() => openLightbox(0)}>
            
            <AppImage
              src={galleryImages[0].src}
              alt={galleryImages[0].alt}
              fill
              priority
              className="object-cover group-hover:scale-105 transition-transform duration-500" />
            
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" />
          </div>

          {/* Right 4 thumbnails */}
          {galleryImages.slice(1, 5).map((img, idx) =>
          <div
            key={img.id}
            className="relative cursor-pointer group overflow-hidden"
            onClick={() => openLightbox(idx + 1)}>
            
              <AppImage
              src={img.src}
              alt={img.alt}
              fill
              className="object-cover group-hover:scale-110 transition-transform duration-500" />
            
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors" />
              {idx === 3 && galleryImages.length > 5 &&
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                  <span className="text-white font-bold text-lg">+{galleryImages.length - 5}</span>
                </div>
            }
            </div>
          )}
        </div>

        {/* View all photos button */}
        <button
          onClick={() => openLightbox(0)}
          className="mt-3 flex items-center gap-2 text-sm font-semibold text-gray-700 hover:text-red-600 border border-gray-200 hover:border-red-300 px-4 py-2 rounded-xl transition-all">
          
          <Camera size={15} />
          View all {galleryImages.length} photos
        </button>
      </div>

      {/* Lightbox */}
      {lightboxOpen &&
      <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center">
          <button
          onClick={closeLightbox}
          className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
          aria-label="Close gallery">
          
            <X size={20} />
          </button>

          <button
          onClick={prev}
          className="absolute left-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
          aria-label="Previous image">
          
            <ChevronLeft size={24} />
          </button>

          <div className="relative w-full max-w-5xl mx-16 aspect-video">
            <AppImage
            src={galleryImages[activeIndex].src}
            alt={galleryImages[activeIndex].alt}
            fill
            className="object-contain" />
          
          </div>

          <button
          onClick={next}
          className="absolute right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
          aria-label="Next image">
          
            <ChevronRight size={24} />
          </button>

          {/* Thumbnails */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {galleryImages.map((img, idx) =>
          <button
            key={`thumb-${img.id}`}
            onClick={() => setActiveIndex(idx)}
            className={`w-14 h-10 rounded-lg overflow-hidden border-2 transition-all ${
            idx === activeIndex ? 'border-red-500 scale-110' : 'border-transparent opacity-60 hover:opacity-100'}`
            }>
            
                <AppImage src={img.thumb} alt={img.alt} width={56} height={40} className="object-cover w-full h-full" />
              </button>
          )}
          </div>

          <div className="absolute top-4 left-1/2 -translate-x-1/2 text-white/60 text-sm font-medium">
            {activeIndex + 1} / {galleryImages.length}
          </div>
        </div>
      }
    </>);

}